<script setup>
import ActionModal from '@/components/modals/ActionModal.vue'
import FormInput from '@/components/Atoms/FormInput.vue'

const isVisible = defineModel('isVisible', { type: Boolean, default: false })
const editedGroupName = defineModel('editedGroupName', { type: String, default: '' })
const emit = defineEmits(['confirm'])
</script>

<template>
	<ActionModal
		v-model:isVisible="isVisible"
		title="Edit Group Name"
		confirm-text="Save"
		cancel-text="Cancel"
		:on-submit="() => emit('confirm')"
	>
		<FormInput v-model="editedGroupName" placeholder="New group name" />
	</ActionModal>
</template>
